<div class="modal-header">
  <h5 class="modal-title">Editar configurações</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="dismiss()"
  ></button>
</div>

<div class="modal-body" [formGroup]="configForm">
  <div class="mb-4">
    <h6 class="fw-bold mb-3">LIMITES FINANCEIROS</h6>

    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label">
          Limite de Saque Automático (Por transação)
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="valorMinimoSaqueAutomatico"
          currencyMask
          [options]="{ prefix: 'R$ ', allowNegative: false }"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Quantidade de Saque em 24h (Por recebedor)
        </label>
        <input
          type="number"
          class="form-control"
          formControlName="amountExpired"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label">Limite de Saque em 24h (Por recebedor)</label>
        <input
          type="text"
          class="form-control"
          formControlName="valueExpired"
          currencyMask
          [options]="{ prefix: 'R$ ', allowNegative: false }"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label d-block">
          Cancelamento Automático de Saque
        </label>
        <label class="custom-switch mt-2">
          <input
            type="checkbox"
            class="custom-switch-input"
            formControlName="analyzeWithdrawal"
          />
          <span class="custom-switch-indicator"></span>
        </label>
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Limites de Saque (Por transação) - Mínimo
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="valueMinRequest"
          currencyMask
          [options]="{ prefix: 'R$ ', allowNegative: false }"
          [class.is-invalid]="hasRangeError('withdraw')"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Limites de Saque (Por transação) - Máximo
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="valueMaxRequest"
          currencyMask
          [options]="{ prefix: 'R$ ', allowNegative: false }"
          [class.is-invalid]="hasRangeError('withdraw')"
        />
        <div *ngIf="hasRangeError('withdraw')" class="mt-1">
          <small class="text-danger">
            O valor máximo de saque não pode ser menor que o mínimo.
          </small>
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Limites de Depósito (Por transação) - Mínimo
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="depositValueMinRequest"
          currencyMask
          [options]="{ prefix: 'R$ ', allowNegative: false }"
          [class.is-invalid]="hasRangeError('deposit')"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Limites de Depósito (Por transação) - Máximo
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="depositValueMaxRequest"
          currencyMask
          [options]="{ prefix: 'R$ ', allowNegative: false }"
          [class.is-invalid]="hasRangeError('deposit')"
        />
        <div *ngIf="hasRangeError('deposit')" class="mt-1">
          <small class="text-danger">
            O valor máximo de depósito não pode ser menor que o mínimo.
          </small>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-2">
    <h6 class="fw-bold mb-3">PERMISSÕES</h6>

    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label d-block">Bloquear Depósito de Terceiros</label>
        <label class="custom-switch mt-2">
          <input
            type="checkbox"
            class="custom-switch-input"
            formControlName="featureFlagRefundPix"
          />
          <span class="custom-switch-indicator"></span>
        </label>
      </div>

      <div class="col-md-6">
        <label class="form-label d-block">
          Bloquear Validação de Titular do Saque
        </label>
        <label class="custom-switch mt-2">
          <input
            type="checkbox"
            class="custom-switch-input"
            formControlName="featureFlagCpfWithdraw"
          />
          <span class="custom-switch-indicator"></span>
        </label>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary btn-pill"
    (click)="save()"
    [disabled]="isSaving || validatingTotp || configForm.invalid"
  >
    Salvar
  </button>
</div>

<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage && errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>

    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        placeholder="Token"
        [(ngModel)]="validationCode"
        [ngModelOptions]="{ standalone: true }"
        (keyup.enter)="validateTotp()"
      />

      <button
        type="button"
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{ "login.totp.pasteButton" | translate }}
      </button>
    </div>
  </div>

  <div class="modal-footer text-center">
    <button
      type="button"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp || isSaving"
    >
      VALIDAR
    </button>
  </div>
</ng-template>